// Packages
import PropTypes from 'prop-types';
import advancedFormat from 'dayjs/plugin/advancedFormat';


// Components
import BTDSkeleton from 'components/BTDUI/BTDSkeleton';

// Other
import './styles.css'
import dayjs from 'dayjs';
import Currency from 'components/BTDUI/Currency';

const BookingListItem = ({ contact_name, created_at, expiry_date, id, isLoading, status, total, trading_name, }) => {

	dayjs.extend(advancedFormat);

	return (
		<>
		<div className="BookingListItem">

			<div className='BookingListItem__date'>
				<p className='blue'>{! isLoading ? '#' + id : <BTDSkeleton />} <span className='red' style={{display: 'inline-block', marginLeft: '10px'}}>{! isLoading && expiry_date && dayjs(expiry_date).isBefore(dayjs()) ? 'exp' : ''}</span></p>
				<p className='blue opacity'>{! isLoading ? dayjs(created_at).format('D MMM YYYY') : ''}</p>
			</div>

			<p className='blue'><span className='BookingListItem__label semi-bold'>Name: </span>{! isLoading ? contact_name : <BTDSkeleton />}</p>
			<p className='blue'><span className='BookingListItem__label semi-bold'>Organisation: </span>{! isLoading ? trading_name : <BTDSkeleton />}</p>
			<p className='blue right'>{! isLoading ? <Currency value={total} /> : <BTDSkeleton />}</p>
			<p className={status === 'Approved' ? 'green centre' : 'blue opacity centre'}>{! isLoading ? status : <BTDSkeleton />}</p>

		</div>

		</>
	)
}

BookingListItem.propTypes = {
	contact_name: PropTypes.string,
	created_at: PropTypes.string,
	expiry_date: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isLoading: PropTypes.bool,
	status: PropTypes.string,
	total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	trading_name: PropTypes.string,
}

BookingListItem.defaultProps = {
	contact_name: null,
	created_at: null,
	expiry_date: null,
	id: null,
	isLoading: false,
	status: null,	
	total: null,
	trading_name: null,
}

export default BookingListItem;